import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { addRequest } from "../modules/actions";

const mapStateToProps = (state) => ({
  state: {
    loadingSave: state.offerRequestReducer.loadingSave,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      addRequest,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
